import type { FC } from 'react';

import { CategoryRect } from 'components/CategoryRectangle';
import type { LeadGroups } from 'constants/leadGroups';

import { Heading, TitleContainer } from './styled';

interface IPageTitle {
    type: LeadGroups;
}

export const PageTitle: FC<IPageTitle> = ({ type }) => (
    <TitleContainer>
        <CategoryRect type={type} />
        <Heading>{type}</Heading>
    </TitleContainer>
);
